import { generateClasses } from "@formkit/themes";

export default {
  config: {
    classes: generateClasses({
      global: {
        // outer: 'mb-6',
        // label: `
        //   mb-1
        //   block
        //   text-white
        //   text-base font-inter font-normal
        // `,
        messages: 'mt-1 mb-0',
        message: 'text-red-500 text-sm font-inter font-normal',
        suffixIcon: `w-4 h-4 absolute top-1/2 right-3 transform -translate-y-1/2 text-white`
      },
      form: {
        messages: 'mt-1 mb-0',
        message: 'text-red-500 text-sm font-inter font-normal',
      },
      datepicker: {
        inner: 'relative',
        panelWrapper:
          'absolute top-[calc(100%_+_0.5em)] shadow-[0_0_1.25em_rgba(0,0,0,.25)] rounded-md p-5 bg-white z-20',
        panelHeader:
          'grid grid-cols-[2.5em_1fr_2.5em] justify-center items-center border-b-2 mb-4 pb-4',
        input: 'selection:bg-blue-400',
        monthsHeader: 'flex items-center justify-center col-start-2 col-end-2',
        timeHeader: 'flex items-center justify-center col-start-2 col-end-2',
        overlayPlaceholder: 'text-gray-400',
        months: 'flex flex-wrap',
        month: `
          flex items-center justify-center
          w-[calc(33%_-_1em)] m-2 p-2 rounded-md
          bg-gray-200
          aria-selected:bg-blue-500 aria-selected:text-white
          focus:outline focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 focus:bg-white focus:text-black
          data-[is-extra=true]:opacity-25
          formkit-disabled:opacity-50 formkit-disabled:cursor-default formkit-disabled:pointer-events-none
        `,
        yearsHeader: 'flex items-center justify-center col-start-2 col-end-2',
        years: 'flex flex-wrap max-w-[35em]',
        year: `
          flex items-center justify-center
          w-[calc(20%_-_1em)] m-2 p-2 rounded-md
          bg-gray-200
          aria-selected:bg-blue-500 aria-selected:text-white
          focus:outline focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 focus:bg-white focus:text-black
          data-[is-extra=true]:opacity-25
          formkit-disabled:opacity-50 formkit-disabled:cursor-default formkit-disabled:pointer-events-none
        `,
        weekDays: 'flex',
        weekDay:
          'flex w-[2.25em] h-[1em] m-1 items-center justify-center rounded-md font-normal lowercase',
        week: 'flex formkit-disabled:opacity-50 formkit-disabled:cursor-default formkit-disabled:pointer-events-none',
        dayCell: `
          flex items-center justify-center
          w-[2.25em] h-[2.25em] m-1 p-2 rounded-md
          bg-gray-200
          aria-selected:bg-blue-500 aria-selected:text-white
          focus:outline focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 focus:bg-white focus:text-black
          data-[is-extra=true]:opacity-25
          formkit-disabled:opacity-50 formkit-disabled:cursor-default formkit-disabled:pointer-events-none
        `,
        timeInput:
          'w-full border-2 border-gray-300 rounded-md p-2 my-[2em] focus-visible:outline-blue-500',
        daysHeader: 'flex items-center justify-center',
        prev: 'mr-auto px-3 py-1 hover:bg-gray-100 hover:rounded-lg col-start-1 col-end-1',
        prevLabel: 'hidden',
        prevIcon: 'flex w-3 select-none [&>svg]:w-full',
        dayButton:
          'appearance-none cursor-pointer px-3 py-1 border-2 rounded-lg mx-1 hover:border-blue-500',
        monthButton:
          'appearance-none cursor-pointer px-3 py-1 border-2 rounded-lg mx-1 hover:border-blue-500',
        yearButton:
          'appearance-none cursor-pointer px-3 py-1 border-2 rounded-lg mx-1 hover:border-blue-500',
        next: 'ml-auto px-3 py-1 hover:bg-gray-100 hover:rounded col-start-3 col-end-3',
        nextLabel: 'hidden',
        nextIcon: 'flex w-3 select-none [&>svg]:w-full',
        openButton: `
          appearance-none border-0 bg-transparent flex p-0 self-stretch cursor-pointer
          focus-visible:outline-none focus-visible:text-white focus-visible:bg-blue-500
        `,
        calendarIcon:
          'flex w-8 grow-0 shrink-0 self-stretch select-none [&>svg]:w-full [&>svg]:m-auto [&>svg]:max-h-[1em] [&>svg]:max-w-[1em]',
      },
      text: {
        inner: 'relative',
        input: `
          py-3 px-3
          border-[#D0D5DD]
          bg-white
          font-inter
          font-medium
          rounded-md focus:shadow-outline focus:outline-none
          text-base text-[#101828] placeholder:text-[#667085]
        `,
      },
      number: {
        inner: 'relative',
        input: `
          py-3 px-3
          border-[#D0D5DD]
          bg-gray-50
          font-inter
          font-medium
          rounded-md focus:shadow-outline focus:outline-none
          text-base text-[#101828] placeholder:text-[#667085]
        `,
      },
      date: {
        inner: 'relative',
        input: `
          py-3 px-3
          border-[#D0D5DD]
          bg-gray-50
          font-inter
          font-medium
          rounded-md focus:shadow-outline focus:outline-none
          text-base text-[#101828] placeholder:text-[#667085]
        `,
      },
      password: {
        inner: 'relative',
        input: `
          py-3 px-3
          border-[#D0D5DD]
          bg-white
          font-inter
          rounded-md focus:shadow-outline focus:outline-none
          text-base text-[#667085] placeholder:text-[#667085]
        `
      },
      radio: {},
      file: {},
      checkbox: {
        inner: 'relative',
        input: 'w-4 h-4',
        label: 'ml-2 text-[#475467] font-semibold text-sm font-inter',
      },
      select: {
        inner: 'relative',
        input: `
          w-full rounded-lg
          px-5 py-2.5
          outline-0 border-[#D0D5DD] bg-white
          leading-[1.6] text-[#101828] font-inter font-medium
        `,
        // inner: 'relative',
        // input: `
        //   w-full rounded-md
        //   px-3 py-[0.32rem]
        //   outline-0 border border-white bg-transparent
        //   leading-[1.6] text-white font-inter font-normal
        // `,
        // icon: 'w-4 h-4 absolute top-1/2 right-3 transform -translate-y-1/2 text-white'
      },
      email: {
        input: `
          py-3 px-3
          border-[#D0D5DD]
          bg-white
          font-inter
          font-medium
          rounded-md focus:shadow-outline focus:outline-none
          text-base text-[#101828] placeholder:text-[#667085]
        `
      },
      submit: {
        input: 'inline-block w-full rounded-lg bg-[#0060EE] py-2 px-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-base font-semibold leading-normal text-white'
      }
    })
  }
}